// Detect stale Vite chunks after a prod rebuild while a tab is still open.
// When the running bundle references an old content-hashed chunk, dynamic
// import throws. Reload once after clearing service-worker caches so the tab
// gets the current shell and chunk map.

import { isEvalAiSingleAttemptPolicyActive } from '../services/eval-ai-single-attempt-policy';

export function isStaleChunkError(error: unknown): boolean {
    if (!error) return false;
    const msg = String((error as { message?: unknown })?.message || error || '');
    return /Failed to fetch dynamically imported module|Loading chunk \d+ failed|Importing a module script failed|error loading dynamically imported module/i.test(msg);
}

export function tryStaleChunkRecovery(error: unknown): boolean {
    if (!isStaleChunkError(error)) return false;
    // An evaluator run owns a frozen application context. Reloading that tab,
    // unregistering its service worker, deleting shared caches or even setting
    // the one-shot Storage key would both violate read-only execution and make
    // an already-paid run unrecoverable. The runner must stop in its existing
    // stale-import failure path instead.
    if (isEvalAiSingleAttemptPolicyActive()) return false;
    if (typeof window === 'undefined') return false;

    try {
        if (sessionStorage.getItem('qm_stale_chunk_recovered') === '1') return false;
        sessionStorage.setItem('qm_stale_chunk_recovered', '1');

        if (navigator.serviceWorker) {
            navigator.serviceWorker
                .getRegistrations()
                .then((registrations) => registrations.forEach((registration) => registration.unregister()))
                .catch(() => {});
        }

        if (window.caches) {
            caches
                .keys()
                .then((keys) => keys.forEach((key) => caches.delete(key)))
                .catch(() => {});
        }

        setTimeout(() => window.location.reload(), 150);
        return true;
    } catch {
        return false;
    }
}
